import { useEffect, useState }   from 'react';
import { queriesHaveData }       from '../store/_apolloUtil';
import { useQuery }              from '@apollo/react-hooks';
import { DecisionEngineQueries } from '../queries';
import { Uuid }                  from '../types';

type UseInitialCategoryHookMethod = () => UseInitialCategoryHook;

export type UseInitialCategoryHook = {
	firstCategoryId: Uuid
};

export const useInitialCategory: UseInitialCategoryHookMethod = () => {
	
	const [ firstCategoryId, setFirstCategoryId ] = useState( null );
	
	let firstCategoryIdReq = useQuery( DecisionEngineQueries.queries.GET_CATEGORIES( `id` ), {
		variables: { where: { ordinal: { eq: 0 } } }
	} )
	
	useEffect( () => {
		
		if( queriesHaveData( firstCategoryIdReq ) ){
			
			setFirstCategoryId( firstCategoryIdReq.data?.categories[ 0 ]?.id ?? null );
		}
		
	}, [ firstCategoryIdReq ] )
	
	return { firstCategoryId };
};
